// @ts-nocheck
import componentsReducer, { StoreComponentsActions } from "@store/Framework/Store/Store/Components/ComponentsReducer";
import { combineReducers } from "redux";

const storeReducer = combineReducers({
    components: componentsReducer,
});

export type StoreActions = StoreComponentsActions;

export default storeReducer;
